import { business } from "../config/business";

// Builds a WhatsApp deep link pre-filled with submitted form data.
// There's no WhatsApp Business API/webhook in this app (that requires a paid,
// server-side integration), so "form data going to WhatsApp" is implemented
// the honest, working client-side way: open the user's own WhatsApp with a
// message already composed, ready to send to the business number.
export const buildWhatsAppMessage = (title, fields) => {
  const lines = Object.entries(fields)
    .filter(([, value]) => value)
    .map(([label, value]) => `*${label}:* ${value}`);
  return [`*${title}*`, "", ...lines].join("\n");
};

export const openWhatsAppWithMessage = (title, fields) => {
  const message = buildWhatsAppMessage(title, fields);
  const url = `https://api.whatsapp.com/send?phone=${business.whatsapp.number}&text=${encodeURIComponent(message)}`;
  window.open(url, "_blank");
};
